import { type NotificationsKind } from './notifications.types';

export function isNotificationsKind(value: string | null): value is NotificationsKind {
  return value === 'messages' || value === 'notifications';
}
